module.exports = __webpack_public_path__ + "assets/deda8c9c56b6dfb032888f38329ed24d.svg";